<template>
  <div class="home">
    <div>
      <div id="banner">
        <img id="logo" src="../assets/logo.png">
      </div>
      <div class="background-container">
        <div class="content-container">
          <div class="content-item">
            <img class="image-content" src="../assets/snapshot_cards.png">
            <div class="text-content"><p>{{ contentParagraph }}</p></div>
          </div>
        </div>
        <div class="content-button">
          <a class="buy-button" href="https://crustore.org/?s=snapshot&post_type=product">BUY CARDS</a>
        </div>
        <div class="content-button">
          <a class="card-button" href="https://drive.google.com/file/d/1tGrer0nY9V0LfLrITki9F8ACMh6K1w-k/view">USE VIRTUAL CARDS</a>
        </div>
      </div>
      <div class="question-container">
        <div class="question-text-container">
          <div class="question-text-item question-title">QUESTION GENERATOR</div>
          <div class="question-text-item question-content">{{ questionContentText }}</div>
        </div>
        <div>
          <button class="question-button" v-on:click="getLightQuestion">LIGHT QUESTIONS</button>
          <div class="question"><p>{{ lightQuestion }}</p></div>
        </div>
        <div>
          <button class="question-button" v-on:click="getDeepQuestion">DEEP QUESTIONS</button>
          <div class="question"><p>{{ deepQuestion }}</p></div>
        </div>
        <div>
          <button class="question-button" v-on:click="getSpirutualQuestion">SPIRITUAL QUESTIONS</button>
          <div class="question"><p>{{ spiritualQuestion }}</p></div>
        </div>
        
      </div>
              

    </div>
    <div class="button-container">
        <a class="form-button" href="https://forms.gle/cWdokUqHy6Psk7698">ADD A QUESTION</a>
    </div>
    <div class="form-item">Suggest some other questions to add to our lists!</div>
    <footer>
      <a href="https://www.cru.org/" class="footer-content">cru.org</a>
    </footer>

  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      questionTitleText: '',
      questionContentText: 'There\'s no end to the great conversations you can have with snapshot cards. Click the buttons below for more great questions!',
      lightQuestion: '',
      deepQuestion: '',
      spiritualQuestion: '',
      contentParagraph: 'Designed to help start spiritual conversations, this unique tool contains 52 pictures that are available on standard playing cards or as a simple picture cards. Snapshot Cards come in a plastic case and can be carried with you any where. Instructions on how to use the cards are included with each deck.',
      lightQuestions: [
        {
          category: 'Light',
          question: 'Which picture makes you feel happy?'
        },
        {
          category: 'Light',
          question: 'Which picture causes you to feel the most angry?'
        },
        {
          category: 'Light',
          question: 'Which picture describes your personality?'
        },
        {
          category: 'Light',
          question: 'Which picture describes your best friend?'
        },
        {
          category: 'Light',
          question: 'Which picture would your friends chose to describe you?'
        },
        {
          category: 'Light',
          question: 'Which picture best represents your relationship with your family?'
        },
        {
          category: 'Light',
          question: 'Which picture describes what you would like to accomplish in your life?'
        },
        {
          category: 'Light',
          question: 'Which picture represents how you want people to remember you?'
        },
        {
          category: 'Light',
          question: 'Which picture describes what you like to do in your free time?'
        },
        {
          category: 'Light',
          question: 'Which picture shows what you would do all day if money was not an issue and you didn’t have to go to school?'
        }
      ],
      deepQuestions: [
        {
          category: 'Deep',
          question: 'Which picture describes your greatest fear?'
        },
        {
          category: 'Deep',
          question: 'Which picture describes how you feel about yourself?'
        },
        {
          category: 'Deep',
          question: 'Which picture describes your childhood?'
        },
        {
          category: 'Deep',
          question: 'Which picture would describe what your life is like right now?'
        },
        {
          category: 'Deep',
          question: 'Which picture would describe what you would like your life to look like, either now or in the future?'
        },
        {
          category: 'Deep',
          question: 'Which picture describes your parent\'s relationship with each other?'
        },
        {
          category: 'Deep',
          question: 'Which picture describes what you would change about your life?'
        },
        {
          category: 'Deep',
          question: 'Which picture dest describes your purpose here on earth?'
        },
        {
          category: 'Deep',
          question: 'Which picture describes love to you?'
        },
        {
          category: 'Deep',
          question: 'Which picture describes your first memory and one that describes what you want your last memory to be?'
        }
      ],
      spiritualQuestions: [
        {
          category: 'Spiritual',
          question: 'Which picture describes your thoughts about what God is like?'
        },
        {
          category: 'Spiritual',
          question: 'Which picture describes who Jesus is to you?'
        },
        {
          category: 'Spiritual',
          question: 'Which picture describes the biggest problems of the world today?'
        },
        {
          category: 'Spiritual',
          question: 'Which picture describes the condition of people’s hearts?'
        },
        {
          category: 'Spiritual',
          question: 'Which picture shows what God thinks about you? '
        },
        {
          category: 'Spiritual',
          question: 'Which picture describe Jesus’ main purpose for the world?'
        },
        {
          category: 'Spiritual',
          question: 'Which picture describes any spiritual experiences that you have had?'
        },
        {
          category: 'Spiritual',
          question: 'Which picture shows what happens after you die?'
        },
        {
          category: 'Spiritual',
          question: 'Which picture describes what a relationship with God would look like? Or what you would like it to look like.'
        },
        {
          category: 'Spiritual',
          question: 'Which picture shows the obstacles that keep you from believing in or trusting God.'
        }
      ]
    }
  },
  methods: {
    getLightQuestion: function () {
      var newQuestion = this.lightQuestions[Math.floor(Math.random() * this.lightQuestions.length)]
      this.lightQuestion = newQuestion.question
    },
    getDeepQuestion: function () {
      var newQuestion = this.deepQuestions[Math.floor(Math.random() * this.deepQuestions.length)]
      this.deepQuestion = newQuestion.question
    },
    getSpirutualQuestion: function () {
      var newQuestion = this.spiritualQuestions[Math.floor(Math.random() * this.spiritualQuestions.length)]
      this.spiritualQuestion = newQuestion.question
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

@font-face { font-family: 'SourceSansPro'; src: url('../assets/fonts/SourceSansPro-Regular.ttf'); }
@font-face { font-family: 'SourceSansProBold'; src: url('../assets/fonts/SourceSansPro-Bold.ttf'); }

header {
  padding: 20px 0;
}

.button-container {
  padding-top: 60px;
  padding-bottom: 30px;
}

.background-container {
  padding-top: 50px;
  padding-bottom: 30px;
  background-color: #ffffff;
}

.content-container {
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  width: 95%;
  background-color: #ffffff;
}

.content-item {
  position: relative;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.form-item {
  position: relative;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  font-size: 14pt;
  font-family: 'SourceSansProBold';
}

.image-content {
  position: relative;
  display: inline-block;
  width: 350px;
  max-width: 95%;
}

.text-content {
  position: relative;
  margin: 0;
  display: inline-block;
  width: 19em;
  max-width: 95%;
  font-size: 16pt;
  text-align: left;
}

.question-container {
  margin-top: 10px;
  background-color: #00C7E2;
  padding-bottom: 1px;
}

.question-text-container {
  text-align: center;
  padding-top: 15px;
  margin: 14px auto 40px auto;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  color: #ffffff;

}
.question-title {
  width: 6em;
  display: inline-block;
  text-align: right;
  font-size: 26pt;
  margin: 0 5px;
  font-family: 'SourceSansProBold';
}

.question-content {
  display: inline-block;
  width: 15em;
  text-align: left;
  margin: 0 2px;
  font-family: 'SourceSansPro';
}

.text-content {
  margin: 0px 16px 0px 16px;
  font-family: 'SourceSansPro';
}

#logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 200px;
  background-color: #00C7E2;
}

#banner{
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #00C7E2;
}

.question {
  background-color: white;
  margin: 20px auto 60px auto;
  width: 45%;
  text-align: center;
  height: 2em;
  padding: 8px;
  font-size: 16pt;
  line-height: 16pt;
  position: relative;
}

.question p {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;
  font-family: 'SourceSansPro';
}

footer {
  text-align: center;
  background-color: #00C7E2;
  padding: 18px 0 18px 0;
  margin-top: 25px;
  font-size: 14pt;
}

footer a {
  color: #fff;
  font-family: 'SourceSansPro';
  text-decoration: none;
}

.content-button {
  padding-top: 25px;
  padding-bottom: 25px;
}

.buy-button {
  font-size: 20pt;
  padding: 14px 80px;
  cursor: pointer;
  color: #fff;
  background-color: #00C7E2;
  font-size: 1.5rem;
  border: 1px solid #fff;
  margin: 20px;
  font-family: 'SourceSansProBold';
  text-decoration: none;
}

.card-button {
  font-size: 20pt;
  padding: 8px 34px;
  cursor: pointer;
  color: #fff;
  background-color: #00C7E2;
  font-size: 1.5rem;
  border: 1px solid #fff;
  margin: 20px;
  font-family: 'SourceSansProBold';
  text-decoration: none;
}

.form-button {
  font-size: 20pt;
  padding: 10px 30px;
  cursor: pointer;
  color: #fff;
  background-color: #383F43;
  font-size: 1.5rem;
  border: 1px solid #fff;
  font-family: 'SourceSansProBold';
  text-decoration: none;
}

.question-button {
  font-size: 14pt;
  padding: 6px 16px;
  width: 240px;
  cursor: pointer;
  background-color: #ffffff;
  border: 1px solid #fff;
  font-family: 'SourceSansProBold';
}

@media (min-width: 834px) {
  .text-content {
    top: 50%;
    transform: translateY(-50%);
  }
}

@media (max-width: 465px) {
  .question-title {
      text-align: center;
  }
  .question-content {
    text-align: center;
  }
  .question {
    height: 6em;
  }
}

@media (max-width: 330px) {
  .question-title {
      text-align: center;
  }
  .question-content {
    text-align: center;
  }
  .question {
    height: 7em;
  }
}

@media (min-width: 460px){
  .question {
    height: 6em;
  }
}

@media (min-width: 600px){
  .question {
    height: 5em;
  }
}

@media (min-width: 640px){
  .question {
    height: 4em;
  }
}

@media (min-width: 768px){
 .question {
   height: 3em;
  }
}

@media (min-width: 1024px){
 .question {
   height: 3em;
  }
}

@media (min-width: 1200px){
 .question {
   height: 2em;
  }
}
</style>
